import * as types from '../../constants/actionTypes';
import * as defaultState from '../constants/DefaultState';
import { loadState } from '../functions/loadState';

export default function webAppointmentReducer(state = {}, action) {
  let val = null;
  if (action.filter) {
    val = action.filter;
    if (typeof val === "object" && val.text) {
      val = val.text;
    }
  }
  switch (action.type) {
    case types.WEBAPPOINTMENT_ACKNOWLEDGED_WHAT_TO_EXPECT:
      return { ...state, acknowledgedWhatToExpect: action.value };  // bool

    case types.WEBAPPOINTMENT_SET_WHO_FOR:
      return { ...state, forMe: action.value };  // bool

    case types.WEBAPPOINTMENT_SET_PATIENT_SEEN_RECENTLY:
      return { ...state, patientSeenRecently: action.value };  // bool

    case types.WEBAPPOINTMENT_SET_CONTACT_OVER_18:
      return { ...state, contact: { ...state.contact, over18: action.value } };  // bool

    case types.WEBAPPOINTMENT_SET_CONTACT_RELATION:
      return { ...state, contact: { ...state.contact, relation: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_CONTACT_FIRST_NAME:
      return { ...state, contact: { ...state.contact, firstName: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_CONTACT_LAST_NAME:
      return { ...state, contact: { ...state.contact, lastName: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_CONTACT_EMAIL:
      return { ...state, contact: { ...state.contact, email: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_CONTACT_PHONE:
      return { ...state, contact: { ...state.contact, phone: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_FIRST_NAME:
      return { ...state, patient: { ...state.patient, firstName: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_LAST_NAME:
      return { ...state, patient: { ...state.patient, lastName: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_DOB:
      return { ...state, patient: { ...state.patient, dob: action.value } };  // string (date)

    case types.WEBAPPOINTMENT_SET_PATIENT_GENDER:
      return { ...state, patient: { ...state.patient, gender: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_MARITAL_STATUS:
      return { ...state, patient: { ...state.patient, maritalStatus: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_SSN:
      return { ...state, patient: { ...state.patient, ssn: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_ADDRESS1:
      return { ...state, patient: { ...state.patient, address1: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_ADDRESS2:
      return { ...state, patient: { ...state.patient, address2: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_CITY:
      return { ...state, patient: { ...state.patient, city: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_STATE:
      return { ...state, patient: { ...state.patient, state: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_ZIP:
      return { ...state, patient: { ...state.patient, zip: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_EMAIL:
      return { ...state, patient: { ...state.patient, email: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_PHONE:
      return { ...state, patient: { ...state.patient, phone: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_PATIENT_MRN:
      return { ...state, patient: { ...state.patient, mrn: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_REASON:
      return { ...state, appointment: { ...state.appointment, reason: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_DIAGNOSIS:
      return { ...state, appointment: { ...state.appointment, diagnosis: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_PROVIDER:
      return { ...state, appointment: { ...state.appointment, provider: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_DEPARTMENT:
      // THIS IS SPECIAL!  When you set the department, blank out the location.
      return { ...state, appointment: { ...state.appointment, department: action.value, location: "" } };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_LOCATION:
      return { ...state, appointment: { ...state.appointment, location: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_TYPE:
      return { ...state, appointment: { ...state.appointment, type: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_TIME:
      return { ...state, appointment: { ...state.appointment, time: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_DAY:
      return { ...state, appointment: { ...state.appointment, day: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_NEED_SERVICES:
      return {
        ...state,
        appointment: {
          ...state.appointment,
          translationInterpretationServices: {
            ...state.appointment.translationInterpretationServices,
            needServices: action.value   // bool
          }
        }
      };

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_WHICH_SERVICE:
      return {
        ...state,
        appointment: {
          ...state.appointment,
          translationInterpretationServices: {
            ...state.appointment.translationInterpretationServices,
            whichService: action.value    // "asl", "translation", "interpretation"
          }
        }
      };

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_FOREIGN_LANGUAGE:
      return {
        ...state,
        appointment: {
          ...state.appointment,
          translationInterpretationServices: {
            ...state.appointment.translationInterpretationServices,
            language: action.value    // string
          }
        }
      };

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_HAVE_REFERRING_PHYS:
    return {
      ...state,
      appointment: {
        ...state.appointment,
        referringPhysician: {
          ...state.appointment.referringPhysician,
          haveReferringPhys: action.value           // bool
        }
      }
    };

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_REFERRING_FNAME:
      return {
        ...state,
        appointment: {
          ...state.appointment,
          referringPhysician: {
            ...state.appointment.referringPhysician,
            firstName: action.value
          }
        }
      };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_REFERRING_LNAME:
      return {
        ...state,
        appointment: {
          ...state.appointment,
          referringPhysician: {
            ...state.appointment.referringPhysician,
            lastName: action.value
          }
        }
      };  // string

    case types.WEBAPPOINTMENT_SET_APPOINTMENT_REFERRING_PHONE:
      return {
        ...state,
        appointment: {
          ...state.appointment,
          referringPhysician: {
            ...state.appointment.referringPhysician,
            phone: action.value
          }
        }
      };  // string

    case types.WEBAPPOINTMENT_SET_PAYMENT_METHOD:
      return { ...state, paymentMethod: action.value };  // string

    case types.WEBAPPOINTMENT_SET_INSURANCE_COMPANY:
      return { ...state, insurance: { ...state.insurance, company: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_INSURANCE_POLICY_NUMBER:
      return { ...state, insurance: { ...state.insurance, policyNumber: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_INSURANCE_POLICY_TYPE:
      return { ...state, insurance: { ...state.insurance, policyType: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_INSURANCE_GROUP:
      return { ...state, insurance: { ...state.insurance, group: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_INSURANCE_WHERE_TO_SEND:
      return { ...state, insurance: { ...state.insurance, whereToSend: action.value } };  // string

    case types.WEBAPPOINTMENT_SET_INSURANCE_HOLDER_RELATION:
      return { ...state, insurance: { ...state.insurance, policyHolder: { ...state.insurance.policyHolder, relation: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_INSURANCE_HOLDER_FNAME:
      return { ...state, insurance: { ...state.insurance, policyHolder: { ...state.insurance.policyHolder, firstName: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_INSURANCE_HOLDER_LNAME:
      return { ...state, insurance: { ...state.insurance, policyHolder: { ...state.insurance.policyHolder, lastName: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_INSURANCE_HOLDER_DOB:
      return { ...state, insurance: { ...state.insurance, policyHolder: { ...state.insurance.policyHolder, dob: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_INSURANCE_HOLDER_EMAIL:
      return { ...state, insurance: { ...state.insurance, policyHolder: { ...state.insurance.policyHolder, email: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_BILLING_RELATION:
      return { ...state, insurance: { ...state.insurance, billing: { ...state.insurance.billing, relation: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_BILLING_FNAME:
      return { ...state, insurance: { ...state.insurance, billing: { ...state.insurance.billing, firstName: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_BILLING_LNAME:
      return { ...state, insurance: { ...state.insurance, billing: { ...state.insurance.billing, lastName: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_BILLING_DOB:
      return { ...state, insurance: { ...state.insurance, billing: { ...state.insurance.billing, dob: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_BILLING_ADDRESS1:
      return { ...state, insurance: { ...state.insurance, billing: { ...state.insurance.billing, address1: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_BILLING_ADDRESS2:
      return { ...state, insurance: { ...state.insurance, billing: { ...state.insurance.billing, address2: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_BILLING_CITY:
      return { ...state, insurance: { ...state.insurance, billing: { ...state.insurance.billing, city: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_BILLING_STATE:
      return { ...state, insurance: { ...state.insurance, billing: { ...state.insurance.billing, state: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_BILLING_ZIP:
      return { ...state, insurance: { ...state.insurance, billing: { ...state.insurance.billing, zip: action.value } } };  // string

    case types.WEBAPPOINTMENT_SET_REQUEST_RESULTS:
      return { ...state, requestResults: action.value };

    case types.WEBAPPOINTMENT_SET_PFA_CALLBACK_WINDOW_DISMISSED:
      return { ...state, pfaCallbackWindowDismissed: action.value };

    case types.WEBAPPOINTMENT_CLEAR_OUT_DATA:
      return defaultState.defaultState;

    default:
      return loadState();
  }
}
